import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { uniqueId } from 'lodash';

import connectEditElementToBriefStore from 'contest/components/connected/connect-edit-element-to-brief-store';
import { connectReadElement } from 'contest/components/brief/read-element';

const ReadRadioChoiceOtherElement = ({ text }) => <p>{text}</p>;
ReadRadioChoiceOtherElement.propTypes = { text: PropTypes.string.isRequired };

export const ViewRadioChoiceOtherElement = connectReadElement(
    ReadRadioChoiceOtherElement,
    element => {
        if (element.value.hasOwnProperty('other')) {
            return { text: element.value.other };
        } else if (element.value.choice) {
            return { text: element.trans.choices[element.value.choice] };
        } else {
            return { text: '' };
        }
    },
    ({ value }) => value.other != null || value.choice != null
);

export const ViewRadioChoiceElement = connectReadElement(ReadRadioChoiceOtherElement, element => ({
    text: element.trans.choices[element.value],
}));

export class EditRadioChoiceOtherElement extends Component {
    constructor(props) {
        super(props);

        this.handleChoiceChange = this.handleChoiceChange.bind(this);
        this.handleOtherChange = this.handleOtherChange.bind(this);

        const hasChoice = props.value.hasOwnProperty('choice');
        this.state = {
            choice: hasChoice ? props.value.choice : props.otherKey,
        };
    }

    handleChoiceChange(event) {
        this.setState(
            {
                choice: event.target.value,
            },
            () => {
                if (!this.isOtherSelected()) {
                    let value = this.state.choice;
                    if (value == '') {
                        value = null;
                    }
                    this.props.onChange(
                        {
                            choice: value,
                        },
                        true
                    );
                }
            }
        );
    }

    handleOtherChange(event) {
        this.props.onChange(
            {
                other: event.target.value,
            },
            false
        );
    }

    isOtherSelected() {
        return this.props.hasOther && this.state.choice == this.props.otherKey;
    }

    render() {
        const groupId = uniqueId('radio-choice-other_');
        return (
            <div className="field field--checkable-set">
                <div className="field__children">
                    {this.props.allowEmpty && (
                        <div className="field__input">
                            <input
                                type="radio"
                                value=""
                                checked={this.state.choice == null}
                                name={groupId}
                                onChange={this.handleChoiceChange}
                            />
                        </div>
                    )}
                    {Object.keys(this.props.choices).map(key => {
                        const isSelected = this.state.choice == key;
                        const label = this.props.choices[key];
                        const id = uniqueId('radio-choice-other-item_');
                        return (
                            <div className="field field--checkable" key={key}>
                                <div className="field__input">
                                    <input
                                        id={id}
                                        type="radio"
                                        value={key}
                                        checked={isSelected}
                                        name={groupId}
                                        onChange={this.handleChoiceChange}
                                    />
                                </div>
                                <label htmlFor={id} className="field__title">
                                    {label}
                                </label>
                            </div>
                        );
                    })}
                    {this.props.hasOther && this.renderOther(groupId)}
                </div>
            </div>
        );
    }

    renderOther(groupId) {
        const isSelected = this.isOtherSelected();
        const key = this.props.otherKey;
        const label =
            this.props.otherOption ||
            this.props.intl.formatMessage({ id: 'brief_choice_other_option' });
        const id = uniqueId('multiple-choice-other_');
        return (
            <div className="field field--checkable" key={key}>
                <div className="field__input">
                    <input
                        id={id}
                        type="radio"
                        value={key}
                        checked={isSelected}
                        name={groupId}
                        onChange={this.handleChoiceChange}
                    />
                </div>
                <label htmlFor={id} className="field__title">
                    {label}
                </label>
                {isSelected && (
                    <div className="field__children">
                        <div className="field">
                            <div className="field__input">
                                <input
                                    type="text"
                                    className="input-text input-width--max"
                                    defaultValue={this.props.value.other}
                                    placeholder={this.props.otherPlaceholder}
                                    onChange={this.handleOtherChange}
                                    onBlur={this.props.onSave}
                                    autoFocus={true}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
EditRadioChoiceOtherElement.propTypes = {
    value: PropTypes.object.isRequired,
    choices: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    otherKey: PropTypes.string,
    otherPlaceholder: PropTypes.string,
    allowEmpty: PropTypes.bool,
    emptyOption: PropTypes.string,
    otherOption: PropTypes.string,
    hasOther: PropTypes.bool,
};
EditRadioChoiceOtherElement.defaultProps = {
    onChange: () => {},
    onSave: () => {},
    otherKey: '__other__',
    otherPlaceholder: '',
    allowEmpty: true,
    emptyOption: '',
    otherOption: '',
    hasOther: false,
};

const EditRadioChoiceOtherElementWithIntl = injectIntl(EditRadioChoiceOtherElement);

export const ConnectedEditRadioChoiceOtherElement = connectEditElementToBriefStore(
    EditRadioChoiceOtherElementWithIntl,
    element => ({
        value: element.value,
        choices: element.trans.choices,
        hasOther: true,
        otherPlaceholder: element.trans.otherPlaceholder,
        allowEmpty: element.trans.hasOwnProperty('emptyOption'),
        emptyOption: element.trans.emptyOption,
        otherOption: element.trans.otherOption,
    }),
    value => value
);

export const ConnectedEditRadioChoiceElement = connectEditElementToBriefStore(
    EditRadioChoiceOtherElementWithIntl,
    element => ({
        value: {
            choice: element.value,
            other: null,
        },
        choices: element.trans.choices,
        allowEmpty: element.trans.hasOwnProperty('emptyOption'),
        emptyOption: element.trans.emptyOption,
        hasOther: false,
    }),
    ({ choice }) => choice
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/radio-choice-other-element.jsx